import GreyscaleGradientResource from "../utils/GreyscaleGradientResource";
import RainbowGradientResource from "../utils/RainbowGradientResource";
import common from "../common";

export default class ColorPicker extends PIXI.Container {
    constructor() {
        super();

        this._currentColor = new P3.Color();
        this._currentColor.setHex(0xff0000);

        const colorBaseTexture = new PIXI.BaseTexture(new RainbowGradientResource());
        colorBaseTexture.setSize(500, 50);

        const colorTexture = new PIXI.Texture(colorBaseTexture);

        this._colorGradient = new PIXI.Sprite(colorTexture);
        this._colorGradient.anchor.set(0.5);
        this._colorGradient.interactive = true;
        this._colorGradient.mousedown = this._colorGradient.touchdown = this.onColorGradientDown.bind(this);
        this.addChild(this._colorGradient);

        const greyBaseTexture = new PIXI.BaseTexture(new GreyscaleGradientResource(this._currentColor));
        greyBaseTexture.setSize(500, 50);

        const greyTexture = new PIXI.Texture(greyBaseTexture);

        this._greyGradient = new PIXI.Sprite(greyTexture);
        this._greyGradient.anchor.set(0.5);
        this._greyGradient.y = this._colorGradient.height * 0.5 + this._greyGradient.height * 0.5 + 5;
        this._greyGradient.interactive = true;
        this._greyGradient.mousedown = this._greyGradient.touchstart = this.onGreyGradientDown.bind(this);
        this.addChild(this._greyGradient);

        this._colorSwatch = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._colorSwatch.width = 50;
        this._colorSwatch.height = 50;
        this._colorSwatch.anchor.set(0.5);
        this._colorSwatch.position.set(this._colorGradient.width * 0.5 + 30, 30);
        this.addChild(this._colorSwatch);

        this.updateGreyscaleColorGradient();

        this._colorSwatch.tint = this._currentColor.toNumber();

    }

    _pick(point) {

        const pixel = common.renderer.extract.pixel(this, point);
        console.log(pixel);

        const color = new P3.Color();
        color.setRGB(pixel[0] / 255, pixel[1] / 255, pixel[2] / 255);

        return color;
        //  const data = this._colorGradient.getColorByPoint(point);
        //  console.log(data);

        //  context = renderer.rootContext;
        // const pixels = common.renderer.extract.pixels(this._colorGradient);
        /*
        const canvas = common.renderer.extract.canvas(this._colorGradient);
        const context = canvas.getContext('2d');

        const data = context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        console.log(data);

         */

        /*
        let canvas, context;
        const imgSource = this._colorGradient.texture.baseTexture.resource.source;

        if (imgSource.getContext) {
            canvas = imgSource;
            context = canvas.getContext('2d');
            //console.log(context);
        }

        const data = context.getImageData(point.x, point.y, 1, 1).data;
        console.log(data);

         */
        // const data = this._pixels(point, this._colorGradient);
        // console.log(data);
        // common.renderer.bindAndClearTexArray(this._colorGradient);


        /*
        const resolution = this._colorGradient.texture.resolution;
        const pixels = new Uint8Array(4);
        const gl = common.renderer.gl;
        gl.readPixels(
            point.x ,
            point.y,
            1,
            1,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            pixels
        );
        //common.renderer.bindAndClearTexArray(null);

        const color = new P3.Color();
        color.setRGB(pixels[0] / 255, pixels[1] / 255, pixels[2] / 255);

        return color;


        /// return this._tileColorMap.get(color.toHex());

         */
        //  const resolution = this._colorGradient.texture.resolution;

        /*
        common.renderer.renderTexture.bind(this._colorGradient.texture);

        const pixels = new Uint8Array(4);
        const gl = common.renderer.gl;
        gl.readPixels(
            point.x,
            point.y,
            1,
            1,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            pixels
        );
        //common.renderer.bindAndClearTexArray(null);
        common.renderer.renderTexture.bind(null);

        const color = new P3.Color();
        color.setRGB(pixels[0] / 255, pixels[1] / 255, pixels[2] / 255);

        return color;

         */
    }

    updateGreyscaleColorGradient() {
        // keep reference to old texture so we can destroy it after swapping
        const previousTexture = this._greyGradient.texture;

        const greyBaseTexture = new PIXI.BaseTexture(new GreyscaleGradientResource(this._currentColor));
        greyBaseTexture.setSize(500, 50);

        this._greyGradient.texture = new PIXI.Texture(greyBaseTexture);

        previousTexture.destroy(true);
    }

    onColorGradientDown(event) {
        const position = event.data.getLocalPosition(this._colorGradient);//event.data.global;//
        position.x += this._colorGradient.width * 0.5; // offset origin
        position.y += this._colorGradient.height * 0.5; // offset origin
        //  position.x = 10;
        // position.y = 10;
      //  console.log(position);
        const color = this._pick(position);
     //   console.log(color);

        this._currentColor = color;

        this._colorSwatch.tint = color.toNumber();

        //this._greyGradient.tint = this._currentColor.toNumber();
        this.updateGreyscaleColorGradient();

    }

    onGreyGradientDown(event) {
        const position = event.data.getLocalPosition(this._greyGradient);//event.data.global;//
        position.x += this._greyGradient.width * 0.5; // offset origin
        position.y += this._greyGradient.height * 0.5 + this._greyGradient.y; // offset origin

        const color = this._pick(position);
        this._colorSwatch.tint = color.toNumber();
        /*
        const percent = 1.25 - position.x / this._greyGradient.width;

        console.log(percent);

        const blended = new P3.Color();
        blended.setRGB(this._currentColor.r, this._currentColor.g, this._currentColor.b);
        blended.r *= percent;
        blended.g *= percent;
        blended.b *= percent;

        this._colorSwatch.tint = blended.toNumber();

         */


        // const blended = new P3.Color();
        //  blended.setRGB(this._currentColor.r, this._currentColor.g, this._currentColor.b);
        // blended.r *= percent;
        //  blended.g *= percent;
        //  blended.b *= percent;

        //this._colorSwatch.tint = blended.toNumber();

        //const shaded = shadeColor(this._currentColor.toString(), percent);

        // this._colorSwatch.tint = shadeColor(this._currentColor, percent * 100).toNumber();

        //  console.log(shadeColor(this._currentColor, percent * 100).toNumber());


        //this._colorSwatch.tint = lighten(this._currentColor.toNumber() * 255, percent) / 255;

        // console.log(shadeColor())

        /*
        const shadedHex = shadeColor(P3.Color.hexNumberToString(this._currentColor.toNumber()), percent * 1000);

        console.log(shadedHex);

        const shaded = new P3.Color();
        shaded.setHex(shadedHex);

        this._colorSwatch.tint = shaded.toNumber();

        function shadeColor(color, percent) {

            var R = parseInt(color.substring(1, 3), 16);
            var G = parseInt(color.substring(3, 5), 16);
            var B = parseInt(color.substring(5, 7), 16);

            R = parseInt(R * (100 + percent) / 100);
            G = parseInt(G * (100 + percent) / 100);
            B = parseInt(B * (100 + percent) / 100);

            R = (R < 255) ? R : 255;
            G = (G < 255) ? G : 255;
            B = (B < 255) ? B : 255;

            var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
            var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
            var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

            return "#" + RR + GG + BB;
        }

         */

        /*
        function lighten(color, percent) {
            var num = color,
                amt = Math.round(2.55 * percent),
                R = (num >> 16) + amt,
                B = (num >> 8 & 0x00FF) + amt,
                G = (num & 0x0000FF) + amt;

            return (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255));
        }

         */

        //  position.x = 10;
        // position.y = 10;
        /*
        console.log(position);
        const color = this._pick(position);
        console.log(color);

        // const blended = new P3.Color();
        //  blended.setFr
        // blended.
        //  const blended = new P3.Color();
        //blended.setRGB(color);
        // this._currentColor.r *= color.r;
        // this._currentColor.g *= color.g;
        // this._currentColor.b *= color.b;

        const blended = new P3.Color();
        blended.setRGB(this._currentColor.r, this._currentColor.g, this._currentColor.b);
        blended.r += color.r;
        blended.g += color.g;
        blended.b += color.b;

        this._colorSwatch.tint = color.toNumber();

         */
        // this._colorSwatch.tint = color.toNumber() + this._currentColor.toNumber();
    }
}